import { useCallback, useEffect, useState } from 'react';
import { fetchResponseAdapter } from '../adapters/fetchAdapter';
import useCallApiAndLoad from './useCallApiAndLoad';
import { Paginator } from '../models/formModel';
import useAuth from './useAuth';

function useAdminEntity<T,>(
  endpoint: Function,
  errorRepository: Function,
  postActions?: (item: T, pagination?: Paginator) => void,
): [T, Function, boolean]
{
  const { isLoading, callEndpoint } = useCallApiAndLoad();
  const [item, setItem] = useState<T>();
  
  const loadItem = useCallback(async () => {
    console.log('🏭 useAdminEntity: Iniciando loadItem');
    
    try {
      const endpointResult = endpoint();
      console.log('🏭 Endpoint result:', endpointResult);
      
      if (!endpointResult) {
        console.log('🏭 Endpoint es null, saltando llamada');
        return;
      }

      const { status, data } = await callEndpoint(endpointResult);
      
      console.log('🏭 Status recibido:', status);
      console.log('🏭 Data recibida:', data);

      // CAMBIO MÍNIMO: Aceptar códigos 2xx en lugar de solo 200
      if (status >= 200 && status < 300) {
        console.log('✅ useAdminEntity: Status exitoso:', status);
        
        const response = fetchResponseAdapter(data);
        let actualResponse;
        let paginator;

        if (response.data.items && response.data.items.length >= 0) {
          actualResponse = response.data.items;
          paginator = response.data.meta;
        } else {
          actualResponse = response.data;
        }

        setItem(actualResponse as T);

        if (postActions) {
          console.log('🎉 useAdminEntity: Ejecutando postActions');
          postActions(actualResponse as T, paginator as Paginator);
          console.log('🎉 useAdminEntity: postActions completado');
        }
      } else {
        console.error('❌ useAdminEntity: Status no exitoso:', status);
        throw new Error(`HTTP Status ${status}: Request failed`);
      }
    } catch (error: any) {
      console.error('❌ useAdminEntity: Error en loadItem:', error);
      throw error;
    }
  }, [callEndpoint, endpoint, postActions]);

  useEffect(() => {
    console.log('🔍 useAdminEntity: useEffect ejecutándose');
    loadItem().catch(e => {
      console.error('🔥 useAdminEntity: Error capturado en useEffect:', e);
      errorRepository(e.toString());
    });
  }, [loadItem, errorRepository]);

  return [
    item as T,
    loadItem as Function,
    isLoading as boolean
  ];
}

export default useAdminEntity;